/**
 * Product recommendations — Splide carousel (live-style mobile peek)
 */
(function () {
  'use strict';

  function initRecommendationsSlider(section) {
    var slider = section.querySelector('[data-ci-rec-slider]');
    if (!slider || !window.Splide) return null;
    if (slider._ciSplide) {
      slider._ciSplide.destroy(true);
      slider._ciSplide = null;
    }

    var slideCount = slider.querySelectorAll('.splide__slide').length;
    if (slideCount < 1) return null;

    var splide = new Splide(slider, {
      type: 'slide',
      rewind: false,
      perPage: 4,
      perMove: 1,
      gap: 24,
      pagination: false,
      arrows: slideCount > 4,
      speed: 400,
      breakpoints: {
        // Live ProductList--carousel @ ≤1007: cell 48% via track padding 26%+26%
        // (perPage:1 + padding — NOT fixedWidth%, which shrinks against padded track)
        1007: {
          perPage: 1,
          gap: 0,
          padding: { left: '26%', right: '26%' },
          focus: 'center',
          arrows: false,
        },
        // Live @ ≤640: cell 62% via padding 19%+19%
        640: {
          perPage: 1,
          gap: 0,
          padding: { left: '19%', right: '19%' },
          focus: 'center',
          arrows: false,
        },
      },
    });

    splide.mount();
    slider._ciSplide = splide;
    return splide;
  }

  function initSection(section) {
    if (!section || section.dataset.ciRecInit === 'true') {
      initRecommendationsSlider(section);
      return;
    }
    section.dataset.ciRecInit = 'true';
    initRecommendationsSlider(section);
  }

  window.ciInitProductRecommendations = initSection;

  function boot() {
    document.querySelectorAll('[data-ci-product-recommendations]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
